var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c("back-button", { attrs: { returnUrl: _vm.returnUrl } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "1" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "3", xl: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary" },
                        on: { click: _vm.actionAdd },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("common.email.email_sender_add"))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-row", { staticClass: "justify-content-center mb-5" }, [
              _c(
                "div",
                [
                  _vm.activateSpinner
                    ? _c("spinner")
                    : _vm.listItemsEmailSender.length > 0
                    ? _c("b-table", {
                        key: _vm.refreshKey,
                        staticClass: "table-striped",
                        attrs: {
                          items: _vm.listItemsEmailSender,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          fixed: "",
                          hover: "",
                          selectable: _vm.listItemsEmailSender.length > 0,
                          "empty-text": _vm.$t("common.security.no_result"),
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "row-selected": _vm.onRowClicked,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(SenderName)",
                            fn: function (data) {
                              return [_c("span", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(edit)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-center d-inline-block py-3 w-100",
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionEdit(
                                          $event,
                                          data.item.IdEmailSender
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-pencil",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(delete)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-center d-inline-block py-3 w-100",
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionDelete(
                                          $event,
                                          data.item.IdEmailSender
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-trash",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      })
                    : _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("span", { staticClass: "noResult" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.no_result")) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }